<template>
  <div>
    <Whatsappcampaign />
  </div>
</template>
<script>
import Whatsappcampaign from "./components/Whatsappcampaign";
export default {
  components: {
    Whatsappcampaign,
  },
};
</script>
